<template>
  <div
    v-if="product?.short_description?.html"
    class="grouped__product-description"
  >
    <span class="grouped__product-description-text">
      {{ product?.short_description?.html }}
    </span>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  product?: {
    description?: {
      html?: string
    }
  }
}>()
</script>

<style>
  @import url("~layers/app/components/Product/GroupedHeading.css");
</style>
